function SizeAndQuantity({ data, state, dispatch, setTab }) {
    const type = state.plain_or_printed.type;

    const handleChangeDiameter = (event) => {
        dispatch({ type: 'size_and_quantity.diameter', value: event.target.value });
    }

    const handleChangeHeight = (event) => {
        dispatch({ type: 'size_and_quantity.height', value: event.target.value });
    }

    const handleChangeQuantity = (event) => {
        dispatch({ type: 'size_and_quantity.quantity', value: event.target.value });
    }

    const choice = data.size_and_quantity[`${type}_choices`].find((item) => {
        return item.diameter === state.size_and_quantity.diameter && item.height === state.size_and_quantity.height;
    });

    let diameters = new Set([]);
    let heights = new Set([]);

    data.size_and_quantity[`${type}_choices`].forEach((item) => {
        diameters.add(parseInt(item.diameter));
        heights.add(parseInt(item.height));
    });

    diameters = Array.from(diameters);
    heights = Array.from(heights);

    return (
        <div className="tab">
            <div className="cols">
                <div>
                    <img src={choice ? choice.image : data.plain_or_printed[type].image} />
                </div>
                <div>
                    <h1 className="title">{data.product.post_title}</h1>
                    <div dangerouslySetInnerHTML={{ __html: data.plain_or_printed[type].description }}></div>
                    <div className="margin-bottom-2">
                        <select defaultValue={state.size_and_quantity.diameter ?? ''} onChange={handleChangeDiameter}>
                            <option value={''} disabled>Internal Diameter</option>
                            {diameters.map((diameter) => (
                                <option key={diameter} value={diameter}>{diameter}mm</option>
                            ))}
                        </select>

                        <select defaultValue={state.size_and_quantity.height ?? ''} onChange={handleChangeHeight}>
                            <option value={''} disabled>Internal Height</option>
                            {heights.map((height) => (
                                <option key={height} value={height}>{height}mm</option>
                            ))}
                        </select>

                        <select defaultValue={state.size_and_quantity.quantity ?? ''} onChange={handleChangeQuantity}>
                            <option value={''} disabled>Quantity</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                            <option value={1000}>1000</option>
                        </select>
                    </div>
                    {choice && state.size_and_quantity.quantity && <div class="unit-price">
                        <span>Unit Price</span>
                        <span>£{choice[`${state.size_and_quantity.quantity}_unit_price`]}</span>
                    </div>}
                </div>
            </div>
            <div className='tab__actions'>
                <button className='btn' onClick={() => setTab('plain_or_printed')}>Back</button>
                <button className='btn' onClick={() => setTab('packaging')} disabled={!choice || !state.size_and_quantity.quantity}>Next</button>
            </div>
        </div>
    )
}

export default SizeAndQuantity
